<!--  会员流转 -->
<template>
    <div class="box">
        <div class="tab-box">
            <div class="store-box flex-start flex-y-center" v-if="regionPostId.includes(postId)">
                <div @click="openRegionPopup" class="region-name-box flex-row flex-between flex-y-center">
                    <div class="name-txt">{{ checkedRegion.name }}</div>
                    <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png" alt="">
                </div>
                <div v-if="checkedStore.id != -1" @click="openRegionStorePopup" class="store-name-box flex-row flex-between flex-y-center">
                    <div class="name-txt">{{ checkedStore.name }}</div>
                    <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png" alt="">
                </div>
            </div>
            <div class="search">
                <form action="/">
                    <van-search class="search-button" v-model="searchStr" @search="onSearch" @clear="selClear" placeholder="搜索姓名/手机" left-icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-07/search.png">
                    </van-search>
                </form>
            </div>
        </div>
        <div class="table">
            <div class="table-tab  flex flex-x-center flex-start">
                <div :class="`tab-item ${tabIndex == 0 ? 'active' : ''}`" @click="clickTab(0)">
                    30天内即将进入公共池
                </div>
                <div :class="`tab-item item-text ${tabIndex == 1 ? 'active' : ''}`" @click="clickTab(1)">
                    会员公共池
                </div>
            </div>
            <div class="box-line"></div>
            <div class="update-time">
                数据更新至{{ updateTime }}
            </div>
            <div class="list-box">
                <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
                    <van-list v-model="loading" :finished="finished" :loading="loading" finished-text="没有更多了" @load="getCustList" :offset="20" :immediate-check="false">
                        <div class="customer-list flex-col" v-for="(item, index) in customerList" :key="index" @click="toDetail(item.custId, item.phone)">
                            <img class="cdpTag" referrerpolicy="no-referrer" v-if="item.cdpTag" :src="item.cdpTag" />
                            <div class="customer-list-box flex-col ">
                                <div class="customer-outer flex-row">
                                    <div class="customer-group flex-col  flex-1">
                                        <div class="customer-info flex-row">
                                            <img class="head-portrait" referrerpolicy="no-referrer" alt="" :src="item.avatar ? item.avatar : 'https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-06/headPortrait.png'" />
                                            <div class="customer-info-box flex-col">
                                                <div class="customer-main flex-row">
                                                    <span class="name" v-html="item.custName"></span>
                                                    <div class="card-grade flex-col">
                                                        <img class="card-image" v-if="item.cardImg" referrerpolicy="no-referrer" :src="item.cardImg" alt="" />
                                                    </div>
                                                </div>
                                                <span class="mobile" v-html="item.mobile"></span>
                                            </div>
                                        </div>
                                        <div class="membership-box flex-row">
                                            <span class="membership-attributes" v-if="tabIndex == 0">专属顾问：{{ item.empName }}</span>
                                            <span class="membership-attributes" v-if="tabIndex == 1">原专属顾问：{{ item.empName }}</span>
                                            <div v-if="item.lifeBeautyCustomerActivity" class="membership-div flex-col">
                                                {{ item.lifeBeautyCustomerActivity }}
                                            </div>
                                        </div>
                                        <span class="card-balance">卡内余额：{{ item.balance ? item.balance : 0 }}元</span>
                                    </div>
                                    <img class="wechat" referrerpolicy="no-referrer" alt="" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-06/dialogue.png" @click.stop="toOpenWechat(item)" />
                                </div>
                                <div class="card-balance" v-if="item.execDate">流失时间：{{ item.execDate }}</div>

                                <span class="arrived-store">最近来店：{{ item.storeName }} {{ item.transDate }}</span>
                            </div>
                            <div class="brithday flex-col">
                                <span class="brithday-txt" v-html="item.birthday"></span>
                            </div>
                        </div>
                    </van-list>
                </van-pull-refresh>
                <!-- 区经区总 切换区域 -->
                <van-popup v-model="showRegionPopup" round position="bottom" closeable class="popup">
                    <picker title="选择区域" v-model="checkedRegion" :list="regionList" @change="onRegionChange"></picker>
                </van-popup>
                <!-- 区经区总 切换门店 -->
                <van-popup v-model="showRegionStorePopup" round position="bottom" closeable class="popup">
                    <picker title="选择门店" v-model="checkedStore" :list="regionStoreList" @change="onRegionStoreChange"></picker>
                </van-popup>
            </div>
        </div>
    </div>
</template>

<script>
    import request from "@/utils/request";
    import { getCookie } from '@/utils'
    import { Toast } from 'vant'
    import { timestampToYestoday } from '@/utils/validate';
    import { openEnterpriseChat } from '@/utils/wxCodeAuth'
    import Picker from '@/components/Picker';
    import { mapState } from 'vuex'
    import { getUserLogin, getRegionStoreList, saveRegionStore } from '@/api/home'

    export default {
        name: "commonPool",
        inject: ['reload'],
        components: {
            Picker
        },
        data() {
            return {
                tabIndex: 0, // tab栏下标
                searchStr: "",
                checkTypeTab: 0,
                loading: false,
                finished: false,
                refreshing: false,
                page: 1,
                total: 0,
                customerList: [],
                updateTime: timestampToYestoday(),   //更新时间
                postId: 0, // 岗位
                showRegionPopup: false,
                showRegionStorePopup: false,
                regionStoreList: [],//区域门店列表
                regionList: [],//区域列表
                checkedRegion: { id: -1, name: '' },//所选区域
                checkedStore: {  //所选门店
                    name: '',
                    id: -1,
                },
            };
        },
        computed: {
            ...mapState({
                regionPostId: (state) => {
                    return state.user.permissions.regionPostId
                },// 区经区总id
            }),
        },
        mounted() {
            this.postId = getCookie('postId') || localStorage.getItem('postId');
            // 获取当前登陆人所记录的区域门店信息
            getUserLogin().then((res) => {
                if (this.regionPostId.includes(this.postId)) {
                    this.checkedRegion.name = res.data.region?.storeName // 当前区域
                    this.checkedRegion.id = res.data.region?.id
                    if (res.data.store) {
                        this.checkedStore.name = res.data.store.storeName //当前门店
                        this.checkedStore.id = res.data.store.id
                        // 门店列表
                        let params = {
                            id: this.checkedRegion.id
                        }
                        getRegionStoreList(params).then((res) => {
                            this.regionStoreList = res.data
                        })
                    }
                    // 区域列表
                    getRegionStoreList().then((res) => {
                        this.regionList = res.data
                    })
                    // 如果当前没有选择门店记录，则进入大区页面
                    if (this.checkedStore.id == 0 || this.checkedStore.id == -1) {
                        this.$router.replace({
                            name: "commonPoolRegionPage"
                        });
                    }
                }
                this.getCustList()

            })
        },
        methods: {
            getCustList() {
                if (this.tabIndex == 0)
                    this.queryType = 1;
                else if (this.tabIndex == 1)
                    this.queryType = 2;

                let params = {
                    keysword: this.searchStr,
                    limit: 10,
                    page: this.page,
                    queryType: this.queryType,
                }
                if (this.regionPostId.includes(this.postId)) {
                    params.id = this.checkedRegion.id
                    params.storeId = this.checkedStore.id
                }
                request({
                    url: `/commonPool/index`,
                    method: "get",
                    params: params
                })
                    .then((res) => {
                        this.customerList = this.page == 1 ? res.data.list : this.customerList.concat(res.data.list);
                        this.page += 1;
                        this.total = res.data.total;
                    }).catch((error) => {
                        this.finished = true
                        Toast({ position: 'top', message: error ?? '' })
                    }).finally(() => {
                        this.loading = false;
                        if (this.customerList.length >= this.total) {
                            this.finished = true;
                        }
                    });
            },
            //跳转顾客详情页
            toDetail(custId, phone) {
                this.$router.push({ name: "customerDetail", query: { custId: custId, phone: phone } });
            },

            // tab切换
            clickTab(tabIndex) {
                this.tabIndex = tabIndex
                this.onRefresh();
            },

            // 查询
            onSearch(e) {
                this.searchStr = e
                this.onRefresh();
            },
            //清除搜索
            selClear() {
                this.searchStr = "";
                this.onRefresh();
            },

            onRefresh() {
                this.page = 1
                // 清空列表数据
                this.finished = false;
                // 重新加载数据
                // 将 loading 设置为 true，表示处于加载状态
                this.loading = true;
                this.customerList = [];
                this.refreshing = false;
                this.getCustList()
            },
            //打开会话
            toOpenWechat(item) {
                if (item.wxExternalUserid && item.isWxContact == 1)   //是好友有userid，打开会话
                    openEnterpriseChat('', item.wxExternalUserid, '', '')
                else
                    //跳转至绑定客户界面
                    this.$router.push({ name: "toBindingCustomer", query: { custName: item.custName, mobile: item.phone, accountNo: item.accountNo, pageName: "commonPool", customerListSearchStr: this.searchStr, customerListQueryType: this.queryType } });
            },
            // 筛选区域门店相关
            openRegionPopup() {
                this.showRegionPopup = true
            },
            onRegionChange(data) {
                this.checkedRegion = data
                this.showRegionPopup = false
                this.$nextTick(() => {
                    // 提交所选区域记录 storeid 覆盖为0给后端判断是区域变更
                    this.checkedStore.id = 0
                    let params = {
                        id: this.checkedRegion.id,
                        storeId: this.checkedStore.id
                    }
                    saveRegionStore(params).then((res) => {
                        this.reload()
                    })
                })
            },
            openRegionStorePopup() {
                this.showRegionStorePopup = true
            },
            onRegionStoreChange(data) {
                this.checkedStore = data
                this.showRegionStorePopup = false
                let params = {
                    id: this.checkedRegion.id,
                    storeId: this.checkedStore.id
                }
                saveRegionStore(params).then(() => {
                    if (data.id == 0 || data.id == -1) {
                        this.$router.replace({
                            name: "commonPoolRegionPage"
                        });
                    } else {
                        this.reload();
                    }
                })

            },
        },
    };
</script>

<style scoped lang="less">
    .box {
        height: 100%;
    }

    .tab-box {
        width: 750px;
        background: #f5f6f7;
    }

    .change-box {
        height: 80px;
        width: 200px;
    }

    .table-tab {
        width: 690px;
        height: 100%;
        display: flex;
    }

    .tab-item {
        height: 42px;
        font-size: 30px;
        font-weight: 400;
        color: #a0acb5;
        text-align: center;
        position: relative;
    }

    .item-text {
        margin-left: 102px;
    }

    .tab-item.active {
        color: #35434c;
        font-weight: bold;
    }

    .tab-item.active::after {
        position: absolute;
        bottom: -20px;
        content: "";
        width: 110px;
        height: 4px;
        background: #37dbe0;
        left: 50%;
        transform: translateX(-50%);
    }

    .box-line {
        width: 690px;
        height: 1px;
        background: #d7d7d7;
        margin: 20px 0 0 30px;
        opacity: 0.5;
    }

    .update-time {
        height: 37px;
        font-size: 26px;
        color: #a0acb5;
        line-height: 37px;
        margin: 30px 30px 0 30px;
    }

    .list-box {
        width: 100%;
        height: 100vh;
        justify-content: space-between;
        margin: 0 auto 0;
        position: relative;
        z-index: 1;
        overflow-y: auto;
        padding: 0 0 250px 0;
    }

    .customer-list {
        z-index: 35;
        min-height: 331px;
        border-radius: 30px;
        background-color: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 26px 0px rgba(2, 2, 2, 0.08);
        width: 690px;
        position: relative;
        margin: 28px auto;
    }

    .customer-list-box {
        width: 632px;
        min-height: 269px;
        margin: 30px 0 30px 30px;
    }

    .customer-outer {
        width: 630px;
        height: 212px;
        margin-left: 2px;
    }

    .customer-group {
        width: 325px;
        height: 212px;
    }

    .customer-info {
        width: 320px;
        height: 88px;
    }

    .head-portrait {
        width: 88px;
        height: 88px;
        border-radius: 45px;
    }

    .cdpTag {
        width: 103px;
        height: 45px;
        position: absolute;
        top: 0;
        left: 0;
    }

    .customer-info-box {
        width: 212px;
        height: 88px;
        margin-left: 30px;
    }

    .customer-main {
        width: 400px;
        height: 48px;
    }

    .name {
        max-width: 260px;
        height: 48px;
        display: inline-block;
        color: rgba(53, 67, 76, 1);
        font-size: 34px;
        line-height: 48px;
        text-align: left;
        overflow: hidden;
        /*溢出的部分隐藏*/
        white-space: nowrap;
        /*文本不换行*/
        text-overflow: ellipsis;
        /*ellipsis:文本溢出显示省略号（...）；clip：不显示省略标记（...），而是简单的裁切*/
    }

    .card-grade {
        height: 34px;
        border-radius: 17px;
        margin-top: 6px;
        margin-left: 20px;
    }

    .txt3 {
        width: 66px;
        height: 30px;
        display: inline-block;
        color: rgba(255, 255, 255, 1);
        font-size: 22px;
        white-space: nowrap;
        line-height: 30px;
        text-align: left;
        margin: 2px 0 0 12px;
    }

    .card-image {
        height: 34px;
        width: 90px;
    }

    .mobile {
        width: 147px;
        height: 37px;
        display: inline-block;
        color: rgba(53, 67, 76, 1);
        font-size: 26px;
        white-space: nowrap;
        line-height: 37px;
        text-align: left;
        margin-top: 6px;
    }

    .membership-box {
        width: 325px;
        height: 37px;
        margin-top: 30px;
    }

    .membership-attributes {
        width: 234px;
        height: 37px;
        display: inline-block;
        color: rgba(121, 138, 148, 1);
        font-size: 26px;
        white-space: nowrap;
        line-height: 37px;
        text-align: left;
    }

    .membership-div {
        padding: 0 5px;
        margin-left: 30px;
        width: 70px;
        height: 34px;
        border-radius: 23px;
        border: 2px solid #2fd0d5;
        color: rgba(47, 208, 213, 1);
        font-size: 22px;
        white-space: nowrap;
        line-height: 34px;
        text-align: center;
    }

    .card-balance {
        width: 234px;
        height: 37px;
        display: inline-block;
        color: rgba(121, 138, 148, 1);
        font-size: 26px;
        white-space: nowrap;
        line-height: 37px;
        text-align: left;
        margin-top: 20px;
    }

    .wechat {
        width: 100px;
        height: 100px;
        padding: 84px 0 0 0;
    }

    .arrived-store {
        width: 579px;
        height: 37px;
        display: inline-block;
        color: rgba(121, 138, 148, 1);
        font-size: 26px;
        white-space: nowrap;
        line-height: 37px;
        text-align: left;
        margin-top: 20px;
    }

    .brithday {
        z-index: 46;
        height: 148px;
        background: url(https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-06/birthdayTag.png) 0px -40px no-repeat;
        background-size: 235px 188px;
        width: 204px;
        position: absolute;
        left: 486px;
        top: 0;
    }

    .empty-txt {
        font-size: 30px;
        color: #a0acb5;
    }

    .empty-icon {
        width: 280px;
        height: 280px;
        margin-top: 179px;
    }

    .brithday-txt {
        width: 81px;
        height: 73px;
        display: inline-block;
        color: rgba(53, 67, 76, 1);
        font-size: 26px;
        line-height: 37px;
        text-align: left;
        margin: 27px 0 0 121px;
        transform: rotate(35deg);
        -webkit-transform-origin-x: 5px;
    }

    .van-pull-refresh {
        min-height: 100%;
    }

    .store-box {
        padding: 30px 30px 0 30px;
        background-color: #fff;

        .store-arrow {
            width: 16px;
            height: 26px;
            margin-left: 8px;
            margin-top: 3px;
        }

        .region-name-box {
            min-width: 239px;
            height: 58px;
            background: #f5f5f5;
            border-radius: 35px;
            margin-right: 10px;
            padding: 10px 15px 11px 16px;
        }

        .store-name-box {
            min-width: 187px;
            height: 58px;
            background: #f5f5f5;
            border-radius: 35px;
            padding: 10px 15px 11px 16px;
        }

        .name-txt {
            color: #66757f;
            font-size: 26px;
        }
    }

    :deep(.search .van-search) {
        background-color: #fff !important;
        padding: 34px 30px 30px 30px !important;
    }

    :deep(.search .van-icon) {
        font-size: 28px;
    }

    :deep(.search .van-search__content) {
        padding-left: 0 !important;
    }

    :deep(.van-field__left-icon) {
        color: #c8c9cc !important;
        padding: 8px 20px 0 20px !important;
        margin-right: 0 !important;
    }

    :deep(.van-tabs__nav) {
        background-color: #f5f6f7 !important;
    }

    :deep(.van-list__finished-text) {
        height: 280px !important;
    }

    :deep(.van-tab--active) {
        font-weight: 400 !important;
    }

    :deep(.van-field__control) {
        font-size: 28px !important;
    }

    :deep(.van-dropdown-menu__title::after) {
        border-color: transparent transparent #35434c #35434c !important;
        border-top-width: 7px !important;
        border-right-width: 7px !important;
        border-bottom-width: 7px !important;
        border-left-width: 7px !important;
        border-top-style: solid !important;
        border-right-style: solid !important;
        border-bottom-style: solid !important;
        border-left-style: solid !important;
    }
</style>
